import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { AlertTriangle, ArrowLeft } from 'lucide-react';

/**
 * Page displayed when user doesn't have permission to access a resource
 */
export const UnauthorizedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="unauthorized-page">
      <div className="max-w-md w-full mx-auto text-center space-y-6 p-6">
        <div className="flex justify-center">
          <div className="rounded-full bg-destructive/10 p-3">
            <AlertTriangle className="h-8 w-8 text-destructive" />
          </div>
        </div>
        
        <div className="space-y-2">
          <h1 className="text-2xl font-bold tracking-tight">
            {t('errors.unauthorized.title', 'Access Denied')}
          </h1>
          <p className="text-muted-foreground">
            {t('errors.unauthorized.description', 
              'You don\'t have permission to access this resource. Please contact your administrator if you believe this is an error.'
            )}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={handleGoBack}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('common.goBack', 'Go Back')}
          </Button>
          <Button onClick={handleGoHome}>
            {t('common.goHome', 'Go to Dashboard')}
          </Button>
        </div>
      </div>
    </div>
  );
};